import { render, staticRenderFns } from "./webhook.vue?vue&type=template&id=509d0e68"
import script from "./webhook.vue?vue&type=script&lang=js"
export * from "./webhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports